import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Layout,
  Row,
  Col,
  Form,
  Button,
  Input,
  Select,
} from "antd";
import "./AddNewPDFFormTemplate.css";
import Dragger from "antd/es/upload/Dragger";

const { Header } = Layout;
const AddNewPDFFormTemplate = () => {
    const navigate = useNavigate();
  const onFinish = (values) => {
    console.log("Success:", values);
    navigate('/leasing/leases/pdf-form-templates')
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onChange = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  return (
    <div className="AddNewPDFFormTemplate">
      <Layout>
        <Header className="header">
          <div className="logo">
            <h1>Add New PDF Form Template</h1>
          </div>
        </Header>
        <br />
        <Row justify="center">
          <Col span={8}>
            <Form
              name="basic"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical"
            >
              <Card title="Upload Form">
                <Form.Item
                  label="Template Name"
                  name="TemplateName"
                  rules={[
                    {
                      required: true,
                      message: "can't be blank",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Template Type"
                  name="TemplateType"
                  rules={[
                    {
                      required: true,
                      message: "can't be blank",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder=""
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        value: "Resident Form",
                        label: "Resident Form",
                      },
                      {
                        value: "Lease/Addendum",
                        label: "Lease/Addendum",
                      },
                    ]}
                  />
                </Form.Item>

                <Form.Item
                  label="Upload a new document template"
                  name="Upload a new document template"
                  rules={[
                    {
                      required: true,
                      message: "Please upload a .pdf file",
                    },
                  ]}
                >
                  <Dragger accept="application/pdf">
                    <Row justify="center" gutter={16} align="middle">
                      <Col>
                        <Form.Item label=" ">
                          <p className="ant-upload-text">Drag File Here</p>
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item label=" ">
                          <span>or</span>
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item label=" ">
                          <Button>Choose File to Add</Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Dragger>
                </Form.Item>
              </Card>
              <br />
              <Row>
                <Col>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Upload PDF Form Template
                    </Button>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item>
                    <Button type="link">Cancel</Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Layout>
    </div>
  );
};

export default AddNewPDFFormTemplate;
